import { render, staticRenderFns } from "./WarehouseSelect.vue?vue&type=template&id=5dc355af&scoped=true"
import script from "./WarehouseSelect.vue?vue&type=script&lang=js"
export * from "./WarehouseSelect.vue?vue&type=script&lang=js"
import style0 from "./WarehouseSelect.vue?vue&type=style&index=0&id=5dc355af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc355af",
  null
  
)

export default component.exports